<template>
  <div class="modal fade" id="confirm-change-price-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          ※変更内容に誤りがないかご確認の上、変更ボタンを押下してください
        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <tr>
                <th rowspan="2">ASIN</th>
                <th colspan="2">Amazon受取金額</th>
                <th colspan="2">STOCKCREW倉庫受取金額</th>
              </tr>
              <tr>
                <th>変更前</th>
                <th>変更後</th>
                <th>変更前</th>
                <th>変更後</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data" :key="i">
                <td :class="{'text-danger': item.error}">{{ item.asin }}</td>
                <td v-if="item.error" class="text-danger" colspan="6">{{ item.error }}</td>
                <template v-else>
                  <td>{{ item.offerPrice.old }}</td>
                  <td><div v-html="item.offerPrice.display"></div></td>
                  <td>{{ item.scOfferPrice.old }}</td>
                  <td><div v-html="item.scOfferPrice.display"></div></td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <div>
            <div v-if="isDisableSubmit" class="font-bold">
              <span class="text-danger">エラーのある項目は赤色で表示されています</span>
              <br>
              <span>データをご確認・修正の上、再アップロードをお願いします</span>
            </div>
          </div>
          <div>
            <button class="btn btn-warning" :disabled="isDisableSubmit" @click="handleSubmitChange()">変更する</button>
            <button class="btn btn-warning" @click="$emit('reUpload')">再アップロード</button>
            <button class="btn" @click="$emit('close')">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    isDisableSubmit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleSubmitChange () {
      if (this.isDisableSubmit) {
        return
      }
      this.$emit('handleSubmitChange')
    }
  },
  mounted () {
    $('#confirm-change-price-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.modal-content {
  padding: 20px 40px;
}
.modal-header {
  color: red;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  padding: unset;
  border-bottom: unset;
}
.modal-body {
  padding: 20px 10px;
  max-height: 500px;
  overflow: auto;
}
.modal-footer {
  display: flex;
  text-align: left;
  justify-content: space-between;
  border-top: unset;
  background-color: inherit;
}
.modal-footer::before {
  content: none;
}
.modal-footer::after {
  content: none;
}
@media (min-width: 1024px) {
  .modal-lg {
    width: 1000px;
  }
}
.table {
  th, td {
    text-align: center;
    border: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ConfirmChangePriceModal.vue